/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useParams,Link,useNavigate } from 'react-router-dom';
import axios from "axios";

import DatePicker from "react-datepicker";
import { ko } from 'date-fns/esm/locale';
import "react-datepicker/dist/react-datepicker.css";

import HeaderTitle from "../../components/includes/HeaderTitle";
import { isObjEmpty,isPassword,isExceptKoreanString,ChangeDateStringOnlyDate,ChangeMobileFormat,ChangeMobileNumber,ChangeSearchingDateFormat,ChangeDateFormat,checkEmailString } from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";

const StaffDetail = ({setMenuType,setMenuItem}) => {
  let { mem_idx } = useParams();
  const navigator = useNavigate();

  //회원정보
  const [varStaffInfo,setStaffInfo] = useState({});
  //은행목록
  const [varBankList,setBankList] = useState([]);
  //소속
  const [varDepartmentList,setDepartmentList] = useState([]);
  //직위
  const [varPositionList,setPositionList] = useState([]);
  //입사일/퇴사일
  const [varStartDate,setStartDate] = useState(null);
  const [varEndDate,setEndDate] = useState(null);

  //신규회원정보
  const newStaff = {mem_idx:0,mem_mode:2,mem_id:"",mem_name:"",mem_pwd:"",mem_pwd2:"",mem_email:"",mem_mobile:"",mem_status:1,mem_rdate:ChangeSearchingDateFormat(new Date(),'.'),
          st_idx:0,st_mg_delivery:0,st_mg_driver:0,st_mg_board:0,st_mg_setting:0,st_department:0,st_position:0,st_sdate:null,st_edate:null,
          bl_code:0,st_account:"",st_owner:"",chk_id:0};

  //회원정보 읽어오기
  const getStaffInformation = async () => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_get_staff_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results?.length > 0){
          let dataInfo = datas.results[0];
          dataInfo.mem_pwd = "";
          setStartDate(new Date(dataInfo.st_sdate));
          if(dataInfo.st_edate !== null) setEndDate(new Date(dataInfo.st_edate));
          setStaffInfo(dataInfo);
        }  else {
          setStaffInfo(newStaff);
        }
        setBankList(datas.banks);
        setDepartmentList(datas.departments);
        setPositionList(datas.positions);
      } else {
        setStaffInfo(newStaff);
      }
    });
  }

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setMenuType('MEMBER');
    setMenuItem('StaffList');
    getStaffInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  //아이디 중복검사
  const onCheckDuplicationIDHandler = async(e) => {
    if(varStaffInfo.mem_id === "") {
      alert('검색할 아이디를 먼저 입력하세요.');return false;
    }
    const sendData = {mem_id:varStaffInfo.mem_id};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_duplicate_id`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        setStaffInfo({...varStaffInfo,chk_id:1});
      } else {
        setStaffInfo({...varStaffInfo,mem_id:""});
      }
      alert(datas.message);
    });
  }

  //정보입력
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "mem_id") {
      const svalue = isExceptKoreanString(value);
      if(varStaffInfo.chk_id === 1) {
        setStaffInfo({...varStaffInfo, [name]:svalue,chk_id:0});
      } else {
        setStaffInfo({...varStaffInfo, [name]:svalue});
      }
    } else if(name === "mem_mobile") {
      setStaffInfo({...varStaffInfo,mem_mobile:ChangeMobileNumber(value)});
    } else if(name === "st_mg_delivery" || name === "st_mg_driver" || name === "st_mg_board" || name === "st_mg_setting" ){
      const ichecked = Number(e.currentTarget.checked);
      console.log(ichecked);
      setStaffInfo({...varStaffInfo,[name]:ichecked});
    } else if(name === "st_department"  || name === "st_position"){
      setStaffInfo({...varStaffInfo,[name]:Number(value)});
    } else {
      setStaffInfo({...varStaffInfo,[name]:value});
    }
  }
  //날짜
  const onChangeDateHandler = (imode,ndate) => {
    if(imode === 0) {
      setStartDate(ndate);
      setStaffInfo({...varStaffInfo,st_sdate:ChangeDateFormat(ndate)});
    } else {
      setEndDate(ndate);
      setStaffInfo({...varStaffInfo,st_edate:ChangeDateFormat(ndate),mem_status:0});
    }
  }

  //직원정보저장
  const onUpdateStaffHandler = async (e) => {
    if(varStaffInfo.mem_id === "") {
      alert('아이디를 먼저 입력하세요.'); return false;
    } else if(varStaffInfo.chk_id === 0) {
      alert('아이디의 중복검사를 먼저 실행하세요'); return false;
    } else if(varStaffInfo.mem_name === "") {
      alert('이름을 먼저 입력하세요.'); return false;
    } else if(varStaffInfo.st_department === "") {
      alert('소속을 먼저 선택하세요.'); return false;
    } else if(varStaffInfo.st_position === "") {
      alert('직위를 먼저 선택하세요.'); return false;
    } else if(varStaffInfo.st_sdate === "") {
      alert('입사일을 먼저 선택하세요.'); return false;
    } else if(varStaffInfo.mem_email === "") {
      alert('이메일을 먼저 입력하세요.'); return false;
    } else if(!checkEmailString(varStaffInfo.mem_email)) {
      alert('입력하신 이메일이 형식에 맞지 않습니다.'); return false;
    } else if(varStaffInfo.mem_mobile === "") {
      alert('연락처를 먼저 입력하세요.'); return false;
    } else if(Number(varStaffInfo.bl_code) === 0) {
      alert('은행을 먼저 선택하세요.'); return false;
    } else if(varStaffInfo.st_account === "") {
      alert('계좌번호를 먼저 입력하세요.'); return false;
    } else if(varStaffInfo.st_owner === "") {
      alert('예금주를 먼저 입력하세요.'); return false;
    }

    if(Number(mem_idx) === 0) {
      if(varStaffInfo.mem_pwd === "") {
        alert('비밀번호를 먼저 입력하세요.'); return false;
      }
    }
    if(varStaffInfo.mem_pwd !== "") {
      if(varStaffInfo.mem_pwd.length < 8 || varStaffInfo.mem_pwd.length > 12) {
        alert('비밀번호는 8~12자리로 입력하세요.'); return false;
      } else if(!isPassword(varStaffInfo.mem_pwd)) {
        alert('입력하신 비밀번호의 형식이 맞지 않습니다.'); return false;
      }
    }

    let sprompt = "직원정보를 저장합니까?";
    if(varStaffInfo.mem_idx === 0) sprompt = "위의 직원정보를 등록합니까?";
    if(!window.confirm(sprompt)) return false;

    const sendData = {staffInfo:varStaffInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/admin_update_staff_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        if(varStaffInfo.mem_idx === 0){
          let memIndex = datas.mem_idx;
          if(window.confirm('새로 등록한 직원을 직원연락망에 등록할까요?')) {
            RegisterStaffCallingNetwork(memIndex,varStaffInfo.mem_mobile);
          }
        } 
        navigator('/Admin/StaffList');
      }
    });
  }
  //직원 연락망에 등록
  const RegisterStaffCallingNetwork = async(mem_idx,mem_mobile) => {
    const sendData = {mem_idx:mem_idx,ah_mode:1,mem_mobile:mem_mobile};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_insert_staff_calling_network`,sendData).then((res) => {
      const datas = res.data;
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigator('/Admin/StaffList');
      }
    });
  }
  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="직원관리" varPageTitle={Number(mem_idx)===0?"직원등록":"직원상세"} />
      {isObjEmpty(varStaffInfo)?null:
        <div className="admin-content">
          <h1 style={{fontSize:"17px",marginTop:"10px"}}>- 계정정보</h1>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>등록일자</th>
                  <td colSpan={3}>{ChangeDateStringOnlyDate(varStaffInfo.mem_rdate)}</td>
                </tr>
                <tr>
                  <th>아이디</th>
                  <td colSpan={3}>
                    <input type="text" name="mem_id" value={varStaffInfo.mem_id} style={{width:"200px"}} onChange={onChangeInputHandler}/>
                    <button className="btn line" onClick={e=>onCheckDuplicationIDHandler(e)}>중복검사</button>
                  </td>
                </tr>
                <tr>
                  <th>비밀번호</th>
                  <td>
                    <input type="password" name="mem_pwd" value={varStaffInfo.mem_pwd} onChange={onChangeInputHandler}/>
                    <div style={{color:"red",fontSize:"14px"}}>영문,숫자,특수문자를 포함하여 8~12자리입니다.</div>
                  </td>
                  <th>비밀번호 확인</th>
                  <td>
                    <input type="password" name="mem_pwd2" value={varStaffInfo.mem_pwd2} onChange={onChangeInputHandler}/>
                    <div style={{color:"red",fontSize:"14px"}}>비밀번호를 확인하기 위해 재입력하세요.</div>
                  </td>
                </tr>
                <tr>
                  <th>권한</th>
                  <td colSpan={3}>
                    <input type="checkbox" name="st_mg_delivery" id="st_mg_delivery" checked={varStaffInfo.st_mg_delivery} onChange={onChangeInputHandler}/>
                    <label htmlFor="st_mg_delivery">배차관리</label>&nbsp;
                    <input type="checkbox" name="st_mg_driver" id="st_mg_driver" checked={varStaffInfo.st_mg_driver} onChange={onChangeInputHandler}/>
                    <label htmlFor="st_mg_driver">기사관리</label>&nbsp;
                    <input type="checkbox" name="st_mg_board" id="st_mg_board" checked={varStaffInfo.st_mg_board} onChange={onChangeInputHandler}/>
                    <label htmlFor="st_mg_board">게시물관리</label>&nbsp;
                    <input type="checkbox" name="st_mg_setting" id="st_mg_setting" checked={varStaffInfo.st_mg_setting} onChange={onChangeInputHandler}/>
                    <label htmlFor="st_mg_setting">설정관리</label>&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h1 style={{fontSize:"17px",marginTop:"10px"}}>- 개인정보</h1>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>이름</th>
                  <td colSpan={3}><input type="text" name="mem_name" value={varStaffInfo.mem_name} style={{width:"200px"}} onChange={onChangeInputHandler}/></td>
                </tr>
                <tr>
                  <th>소속</th>
                  <td>
                    <select name="st_department" value={varStaffInfo.st_department} onChange={onChangeInputHandler}>
                      <option value={0}>소속선택</option>
                      {varDepartmentList.map((depart,i)=>(
                        <option key={'depart_'+i} value={depart.vd_idx}>{depart.vd_name}</option>
                      ))}
                    </select>
                  </td>
                  <th>직위</th>
                  <td>
                    <select name="st_position" value={varStaffInfo.st_position} onChange={onChangeInputHandler}>
                      <option value={0}>직위선택</option>
                      {varPositionList.map((position,i)=>(
                        <option key={'position_'+i} value={position.vp_idx}>{position.vp_name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>입사일</th>
                  <td><DatePicker locale={ko} name="sdate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varStartDate} selectStart onChange={(date)=>onChangeDateHandler(0,date)} /></td>
                  <th>퇴사일</th>
                  <td><DatePicker locale={ko} name="edate" className="datepicker" dateFormat="yyyy.MM.dd" selected={varEndDate} selectEnd minDate={varStartDate} onChange={(date)=>onChangeDateHandler(1,date)} /></td>
                </tr>
                <tr>
                  <th>이메일</th>
                  <td><input type="text" name="mem_email" value={varStaffInfo.mem_email} onChange={onChangeInputHandler}/></td>
                  <th>연락처</th>
                  <td><input type="text" name="mem_mobile" value={ChangeMobileFormat(varStaffInfo.mem_mobile)} onChange={onChangeInputHandler}/></td>
                </tr>
                <tr>
                  <th>근무상태</th>
                  <td colSpan={3}>
                    <select name="mem_status" value={varStaffInfo.mem_status} style={{width:"200px"}} onChange={onChangeInputHandler}>
                      <option value={0}>퇴사</option>
                      <option value={1}>근무중</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h1 style={{fontSize:"17px",marginTop:"10px"}}>- 계좌정보</h1>
          <div className="main-box">
            <table className="write">
              <colgroup><col width="20%"/><col width="30%"/><col width="20%"/><col width="30%"/></colgroup>
              <thead></thead>
              <tbody>
                <tr>
                  <th>은행명</th>
                  <td colSpan={3}>
                    <select name="bl_code" value={varStaffInfo.bl_code} style={{width:"250px"}} onChange={onChangeInputHandler}>
                      <option value={0}>은행선택</option>
                      {varBankList.map((banks,i)=>(
                        <option key={'bank_'+i} value={banks.bl_code}>{banks.bl_name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <th>계좌번호</th>
                  <td><input type="text" name="st_account" value={varStaffInfo.st_account} onChange={onChangeInputHandler}/></td>
                  <th>예금주</th>
                  <td><input type="text" name="st_owner" value={varStaffInfo.st_owner} onChange={onChangeInputHandler}/></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="btn-center">
            <button className="btn line black" style={{width:"100px"}} onClick={(e)=>onUpdateStaffHandler(e)}>저장</button>
            <Link to={`/Admin/StaffList`} className="btn-danger">목록</Link>
          </div>
        </div>
      }
    </div>   
  );
}
export default StaffDetail;